import { sdkRequest } from '@eventbrite/http';

export const checkEbAdsEligibility = async (
    onComplete: Function,
    activeOrganizationId: string,
    skipCache?: boolean,
) => {
    try {
        const valid = isValidTLD();
        const orgId =
            activeOrganizationId ||
            window?.__SERVER_DATA__?.activeOrganizationId ||
            window?.__SERVER_DATA__?.user?.activeOrganization?.id;

        if (!valid || !orgId) {
            onComplete(false);
            return false;
        }

        if (
            !skipCache &&
            typeof window?.__SERVER_DATA__?.isEbAdsEligible !== 'undefined'
        ) {
            onComplete(window.__SERVER_DATA__.isEbAdsEligible);
            return window.__SERVER_DATA__.isEbAdsEligible;
        }

        const userId =
            window.__SERVER_DATA__.user.publicId ||
            window.__SERVER_DATA__.guest_id;

        const url = `/api/v3/promoted_content/organizations/${orgId}/eb-ads-eligibility-split/${userId}${
            skipCache ? '?skip_cache=true' : ''
        }`;

        const data = await sdkRequest(url);
        const is_eligible = data.is_eligible || false;

        onComplete(is_eligible);
        return is_eligible;
    } catch (error) {
        onComplete(false);
        return false;
    }
};

const isValidTLD = () => {
    const tld = window.location.origin.split('.').pop();

    return tld?.includes('com') || tld?.includes('uk') || false;
};
